import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

// ===== MAU16: Steel Industrial — dark charcoal + electric blue, 1-column =====
const Mau16 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const c = {
        bg: '#12141f',
        bg2: '#1a1d2e',
        blue: '#1a6bff',
        blueLight: '#4d8fff',
        blueDark: '#0040cc',
        text: '#ffffff',
        textMuted: 'rgba(255,255,255,0.5)',
        textDark: '#cccccc',
        rowBg: '#1e2135',
        rowBgAlt: '#171929',
        border: 'rgba(26,107,255,0.25)',
        scoreBg: '#1a6bff'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div id={id} style={{
            width, minHeight: width / 1.3,
            fontFamily: 'SFUHelveticaCondensedBold',
            background: `linear-gradient(160deg, ${c.bg} 0%, ${c.bg2} 100%)`,
            position: 'relative', overflow: 'hidden'
        }}>
            {/* Electric blue top stripe */}
            <div style={{ height: `${px * 0.5}px`, background: `linear-gradient(90deg, transparent, ${c.blue}, ${c.blueLight}, ${c.blue}, transparent)` }} />

            {/* HEADER */}
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: `${px * 2}px ${px * 3}px`,
                background: `linear-gradient(90deg, ${c.bg} 0%, rgba(26,107,255,0.12) 50%, ${c.bg} 100%)`,
                borderBottom: `1px solid ${c.border}`,
                position: 'relative'
            }}>
                {/* Diagonal accent */}
                <div style={{ position: 'absolute', left: `${px * 15}px`, top: 0, bottom: 0, width: `${px * 0.2}px`, background: c.blue, opacity: 0.4, transform: 'skewX(-15deg)' }} />
                <div style={{ position: 'absolute', right: `${px * 15}px`, top: 0, bottom: 0, width: `${px * 0.2}px`, background: c.blue, opacity: 0.4, transform: 'skewX(-15deg)' }} />

                <Image src={dataSeason?.logo} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain', filter: `drop-shadow(0 0 6px ${c.blue})`, position: 'relative', zIndex: 1 }} />
                <div style={{ flex: 1, textAlign: 'center', position: 'relative', zIndex: 1 }}>
                    <h1 style={{ color: c.text, fontSize: `${px * 4.8}px`, textTransform: 'uppercase', margin: 0, letterSpacing: `${px * 0.4}px`, textShadow: `0 0 20px rgba(26,107,255,0.6)` }}>
                        {t(titleTemplate(dataSchedules[0]?.dataGo))}
                    </h1>
                    <h2 style={{ color: c.blue, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: `${px * 0.4}px 0 0`, letterSpacing: `${px * 0.2}px` }}>{dataSeason?.name}</h2>
                    {t(numberRound) === numberRound && (
                        <div style={{ display: 'inline-block', background: c.blue, color: '#fff', padding: `${px * 0.3}px ${px * 2.5}px`, borderRadius: `${px * 0.4}px`, fontSize: `${px * 1.9}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px` }}>{t('round')} {numberRound}</div>
                    )}
                    {t(numberRound) && t(numberRound) !== numberRound && (
                        <div style={{ display: 'inline-block', background: c.blue, color: '#fff', padding: `${px * 0.3}px ${px * 2.5}px`, borderRadius: `${px * 0.4}px`, fontSize: `${px * 1.9}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px` }}>{t(numberRound)}</div>
                    )}
                </div>
                <Image src={img} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain', position: 'relative', zIndex: 1 }} />
            </div>

            {/* MATCHES — 1 column */}
            <div style={{ padding: `${px * 1.5}px ${px * 3}px`, display: 'flex', flexDirection: 'column' }}>
                {dataSchedules[0]?.dataGo
                    ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                    ?.map((i, idx) => <Item16 key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} c={c} />)}
            </div>

            {/* SPONSORS */}
            {isShowSponsor && sponsorData?.length > 0 && (
                <div style={{ margin: `0 ${px * 3}px ${px * 2}px`, borderTop: `1px solid ${c.border}`, paddingTop: `${px * 1.5}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: `${px * 2.5}px` }}>
                    {sponsorData?.slice(0, 10)?.map((s, idx) => <Image key={idx} src={s.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />)}
                </div>
            )}
            {/* Blue bottom stripe */}
            <div style={{ height: `${px * 0.5}px`, background: `linear-gradient(90deg, transparent, ${c.blue}, ${c.blueLight}, ${c.blue}, transparent)` }} />

            <p style={{ textAlign: 'right', color: 'rgba(26,107,255,0.5)', fontSize: `${px * 1.6}px`, margin: `${px * 0.8}px ${px * 3}px`, letterSpacing: '2px' }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}</p>
        </div>
    )
}

const Item16 = React.memo(({ data, px, classCustom, idx, c }) => {
    const { t } = useTranslation()
    const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
    const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']
    let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
    let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''
    let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
    let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name
    let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
    let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`
    const isEven = idx % 2 === 0

    return (
        <div style={{ display: 'flex', alignItems: 'center', background: isEven ? c.rowBg : c.rowBgAlt, borderBottom: `1px solid ${c.border}`, padding: `${px * 1.2}px ${px * 1}px`, gap: `${px * 1.2}px`, minHeight: `${px * 10}px` }}>
            {/* Match number */}
            <div style={{ minWidth: `${px * 5.5}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <span style={{ color: c.blue, fontSize: `${px * 2.8}px`, fontWeight: 900, letterSpacing: '-1px' }}>#{String(idx + 1).padStart(2, '0')}</span>
            </div>
            <div style={{ width: `${px * 0.15}px`, alignSelf: 'stretch', background: c.border, flexShrink: 0 }} />
            {/* Home */}
            <div style={{ flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: `${px * 1}px`, overflow: 'hidden' }}>
                <Name16 propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} color={c.text} align="right" />
                <Image src={data?.homeTeam?.logo} style={{ width: `${px * 6}px`, height: `${px * 6}px`, borderRadius: '50%', objectFit: 'cover', border: `${px * 0.25}px solid ${c.blue}`, flexShrink: 0, backgroundColor: '#fff' }} />
            </div>
            {/* Score/VS */}
            <div style={{ minWidth: `${px * 22}px`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.3}px`, flexShrink: 0 }}>
                {data?.isCompleted ? (
                    <>
                        <div style={{ background: c.scoreBg, color: '#fff', fontWeight: 900, fontSize: `${px * 3.2}px`, padding: `${px * 0.3}px ${px * 1.5}px`, borderRadius: `${px * 0.4}px`, letterSpacing: '2px', whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 18}px` }}>
                            {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                            {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                            {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                            {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                        </div>
                        {data?.hasPenalty && <span style={{ color: '#fc0366', fontSize: `${px * 1.3}px`, fontWeight: 'bold', whiteSpace: 'nowrap' }}>PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore}</span>}
                    </>
                ) : (
                    <div style={{ border: `2px solid ${c.blue}`, color: c.blue, fontWeight: 900, fontSize: `${px * 2.6}px`, padding: `${px * 0.3}px ${px * 1.5}px`, borderRadius: `${px * 0.4}px`, letterSpacing: '3px', whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 14}px` }}>VS</div>
                )}
            </div>
            {/* Away */}
            <div style={{ flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: `${px * 1}px`, overflow: 'hidden' }}>
                <Image src={data?.awayTeam?.logo} style={{ width: `${px * 6}px`, height: `${px * 6}px`, borderRadius: '50%', objectFit: 'cover', border: `${px * 0.25}px solid rgba(255,255,255,0.25)`, flexShrink: 0, backgroundColor: '#fff' }} />
                <Name16 propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} color={c.text} align="left" />
            </div>
            {/* Time/Date */}
            <div style={{ minWidth: `${px * 10}px`, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <span style={{ color: c.blue, fontSize: `${px * 2.4}px`, fontWeight: 'bold' }}>{formatDateTime(data?.dateTime, 'time')}</span>
                <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px` }}>{formatDateTime(data?.dateTime, 'date')}</span>
                {data?.stadium && <span style={{ color: c.textMuted, fontSize: `${px * 1.1}px`, maxWidth: `${px * 10}px`, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{data.stadium}</span>}
            </div>
        </div>
    )
}, (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data))

const Name16 = React.memo(({ name, px, propClass, color, align }) => {
    const reSizeBasedOnWidth = () => {
        const el = document.querySelector(`.${propClass}`)
        const container = document.querySelector(`.contain${propClass}`)
        if (!el || !container) return
        const fontSize = window?.getComputedStyle(el)?.fontSize
        el.style.fontSize = parseFloat(fontSize) - 0.25 * px + 'px'
        if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
    }
    const processInput = () => {
        const el = document.querySelector(`.${propClass}`)
        if (!el) return
        el.innerHTML = name
        el.style.fontSize = px * 2.6 + 'px'
        reSizeBasedOnWidth()
    }
    React.useEffect(() => { processInput() }, [name])
    return (
        <div className={`contain${propClass}`} style={{ flex: 1, height: `${px * 7}px`, display: 'flex', alignItems: 'center', justifyContent: align === 'right' ? 'flex-end' : 'flex-start', overflow: 'hidden' }}>
            <h2 className={propClass} style={{ color, textAlign: align, textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2, fontSize: `${px * 2.6}px` }} />
        </div>
    )
}, (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name))

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => { if (props.src) getBase64(props.src).then(r => setData(r)) }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau16, areEqual)
